import { makeStyles } from 'tss-react/mui'
          import { autonomyColor } from '../../global-styles/autonomyColor'

          export const useTextAreaStyles = makeStyles()(() => {
            return {
              textArea: {
                backgroundColor: autonomyColor.mediumBlue,
                width: '100%',
                border: '1px solid ' + `${autonomyColor.mutedBlue}`,
                color: autonomyColor.white,
                borderRadius: 5,
                padding: '5px 10px',
                fontFamily: 'Helvetica Neue',
                fontSize: 15,

                '::placeholder': {
                  color: autonomyColor.mutedBlue,
                },
              },
            }
          })

          export const useSearchbarStyles = makeStyles()((theme) => {
            return {
              root: {
                '&.MuiAutocomplete-root': {
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 50,
                    border: `1px solid ${autonomyColor.mutedBlue}`,
                    [theme.breakpoints.up('lg')]: {
                      width: '60%',
                    },
                    '&.Mui-focused': {
                      borderRadius: '50px !important',
                      border: `1px solid ${autonomyColor.mutedBlue}`,
                    },
                    '& input::placeholder': {
                      color: autonomyColor.white,
                    },
                    '& .MuiSvgIcon-root': {
                      color: autonomyColor.white,
                    },
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none',
                    },
                  },
                },
              },
              popper: {
                color: autonomyColor.white,
                borderRadius: '0px 0px 8px 8px',
                border: `1px solid ${autonomyColor.mutedBlue}`,
                backgroundColor: autonomyColor.darkBlue,
                borderTop: 'none',
              },
              option: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                color: autonomyColor.white,
                margin: '25px 0',
                cursor: 'pointer',
              },
            }
          })
